import { createContext } from 'react';
export const ExpanderContext = /*#__PURE__*/createContext({
  isExpanded: false,
  setIsExpanded: () => {},
  hasExpandableSections: false,
  isExpandableSectionMap: new Map(),
  getExpandableSection: () => false,
  updateExpandableSection: () => {}
});